/* BEATSEEK — Engine Credit: what this BeatSeeker has taught the ID engine.
   Counts are live; the reward tied to them is still being designed. */
import React, { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

export const EngineCredit = ({ userId }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const q = userId ? `?user_id=${encodeURIComponent(userId)}` : '';
    fetch(`${API}/api/track-id/engine-credit${q}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('beatseek_token') || ''}` },
    })
      .then(r => (r.ok ? r.json() : null))
      .then(d => setData(d))
      .catch(() => {});
  }, [userId]);

  if (!data) return null;

  return (
    <div className="engine-credit" data-testid="engine-credit">
      <img src="/beatseek-b-trans-1024.png" alt="BEATSEEK" className="engine-credit-b" />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
        <span className="engine-credit-title">Engine Credit</span>
        <span style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.55)', fontWeight: 300 }}>
          <span className="engine-credit-num" data-testid="engine-credit-confirmations">{data.confirmations}</span> confirmed ·{' '}
          <span className="engine-credit-num" data-testid="engine-credit-corrections">{data.corrections_approved}</span> corrections ·{' '}
          <span className="engine-credit-num" data-testid="engine-credit-fingerprints">{data.fingerprints}</span> fingerprints
        </span>
      </div>
      <span className="engine-credit-soon" data-testid="engine-credit-coming-soon">Rewards coming soon</span>
    </div>
  );
};

export default EngineCredit;
